import React from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Quote, ArrowRight, Sparkles } from "lucide-react";
import { colors, founder } from "../config/site";

const MeetTheFounder = () => {
  return (
    <section
      className="py-20 px-4"
      style={{ backgroundColor: colors.ivory }}
      data-testid="meet-the-founder-section"
    >
      <div className="container mx-auto max-w-7xl">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          {/* Image side */}
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={founder.photo}
                alt={`${founder.name}, Founder of Dorsey Taylor Homes`}
                className="w-full h-[520px] lg:h-[600px] object-cover"
              />
              <div
                className="absolute inset-0"
                style={{
                  background: `linear-gradient(180deg, transparent 55%, ${colors.primaryDark}cc 100%)`,
                }}
              />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <p
                  className="text-xs uppercase tracking-widest font-semibold mb-1"
                  style={{ color: colors.gold }}
                >
                  Founder & CEO
                </p>
                <p className="text-2xl font-bold">{founder.name}</p>
              </div>
            </div>

            {/* Floating accent card */}
            <div
              className="hidden md:flex absolute -bottom-6 -right-6 items-center gap-3 px-5 py-4 rounded-2xl shadow-xl"
              style={{ backgroundColor: colors.white }}
            >
              <div
                className="w-11 h-11 rounded-xl flex items-center justify-center"
                style={{ backgroundColor: "#EFE6D6", color: colors.terracottaDark }}
              >
                <Sparkles className="w-5 h-5" />
              </div>
              <div>
                <p
                  className="text-xs uppercase tracking-wider font-semibold"
                  style={{ color: colors.sage }}
                >
                  Women-Led
                </p>
                <p className="text-sm font-bold" style={{ color: colors.charcoal }}>
                  Community-Rooted
                </p>
              </div>
            </div>
          </div>

          {/* Content side */}
          <div className="lg:col-span-7 space-y-6">
            <div>
              <p
                className="text-xs uppercase tracking-widest font-semibold mb-3"
                style={{ color: colors.terracotta }}
              >
                Meet the Founder
              </p>
              <h2
                className="text-3xl lg:text-4xl font-bold leading-tight"
                style={{ color: colors.charcoal }}
              >
                A community native turning lived experience into{" "}
                <span style={{ color: colors.primary }}>lasting housing change</span>.
              </h2>
            </div>

            {founder.bio.map((paragraph, idx) => (
              <p
                key={idx}
                className="text-base lg:text-lg leading-relaxed"
                style={{ color: colors.textMuted }}
              >
                {paragraph}
              </p>
            ))}

            {/* Pull quote */}
            <div
              className="rounded-2xl p-6 lg:p-7"
              style={{ backgroundColor: colors.white, borderLeft: `4px solid ${colors.terracotta}` }}
            >
              <Quote
                className="w-7 h-7 mb-3"
                style={{ color: colors.terracotta }}
                strokeWidth={2.5}
              />
              <p
                className="text-lg lg:text-xl font-semibold leading-snug"
                style={{ color: colors.charcoal }}
              >
                &ldquo;{founder.quote}&rdquo;
              </p>
              <p
                className="mt-3 text-xs uppercase tracking-wider font-semibold"
                style={{ color: colors.sage }}
              >
                — {founder.name}, {founder.title}
              </p>
            </div>

            {/* Credentials section removed per founder preference */}

            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <Link to="/about" data-testid="founder-learn-more">
                <Button
                  className="text-white rounded-full px-6 py-5 font-semibold"
                  style={{ backgroundColor: colors.primary }}
                >
                  Learn About the Company
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
              <Link to="/contact" data-testid="founder-connect">
                <Button
                  variant="outline"
                  className="rounded-full px-6 py-5 font-semibold border-2"
                  style={{
                    borderColor: colors.terracotta,
                    color: colors.terracotta,
                    backgroundColor: "transparent",
                  }}
                >
                  Connect with Anissa
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetTheFounder;
